import { AmberHoc, AmberHocProps } from '../../../util';
import {
  GrainBinSiteLink,
  UpdateGrainBinSiteLinkMutationVariables as Variables,
  withUpdateGrainBinSiteLink as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';

export type WithUpdateGrainBinSiteLinkHocChildProps = {
  updateGrainBinSiteLink: (variables: Variables) => Promise<GrainBinSiteLink>;
};

export const withUpdateGrainBinSiteLinkHoc: AmberHoc<
  {},
  WithUpdateGrainBinSiteLinkHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<{}, WithUpdateGrainBinSiteLinkHocChildProps, typeof component>,
    WithUpdateGrainBinSiteLinkHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const { mutate } = props;
      return {
        updateGrainBinSiteLink: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected UI error');
          }
          const result = await mutate({
            variables,
            update: (proxy, { data, errors }) => {
              if (errors || !data) {
                return;
              }
            },
          });
          if (!result) {
            throw new Error('Unexpected server response');
          }
          const { data, errors } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data || !data.updateGrainBinSiteLink) {
            throw new Error('Unexpected server response');
          }
          return data.updateGrainBinSiteLink;
        },
      };
    },
  })(component as any);
